import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

import login from './login'
import rong from './rong'
import headurl from './headurl'
import guang from './guang'
import common from './common'


Vue.use(Vuex)

const modules = {
    login,
    rong,
    headurl,
    guang,
    common
}



export default new Vuex.Store({
    modules,
    plugins: [createPersistedState({
        storage: window.sessionStorage,
        reducer(val) {
          return {
            // 只储存state中的login    
            login: val.login,
            headurl:val.headurl
          }
        }
      })],
})




// WEBPACK FOOTER //
// ./src/store/index.js